import * as React from 'react';
import IpoApplicationListView from 'components/Client/IpoApplicationListView';

export interface Props {
    children?: React.ReactNode;
}

export interface State { }

export default class OfferingApplicationListPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return <IpoApplicationListView />
    }
}